<div class="widget-body" [class.dark]="dark" [ngSwitch]="widget.type">

  <!-- ===================== Stat tile ===================== -->
  <div class="widget-stat" *ngSwitchCase="'statTile'" #statWrap>
    <div class="widget-stat-label" [ngStyle]="titleStyle">{{ widget.title || statLabel }}</div>
    <div class="widget-stat-value" #statValueEl>
      <app-rolling-counter [value]="statValue" [decimals]="statDecimals"></app-rolling-counter>
      <span class="widget-stat-unit" *ngIf="statIsRate">/min</span>
    </div>
  </div>

  <!-- ===================== Scan rate by entrance ===================== -->
  <div class="widget-grid-wrap" *ngSwitchCase="'scanRateByEntrance'">
    <div class="widget-heading">
      <span [ngStyle]="titleStyle">{{ widget.title || (hasScanRate ? 'Scan Rate by Entrance' : 'Fans Inside by Entrance') }}</span>
      <span class="widget-heading-sub">{{ hasScanRate ? 'scans per minute' : 'fans inside' }}</span>
    </div>
    <div class="modern-rate-grid" *ngIf="entranceTiles.length; else noData">
      <div class="modern-rate-tile" *ngFor="let ent of entranceTiles">
        <div class="modern-rate-tile-name">{{ ent.name }}</div>
        <ng-container *ngIf="hasScanRate; else entranceInsidePrimary">
          <div class="modern-rate-tile-value">
            <app-rolling-counter [value]="ent.scanRate"></app-rolling-counter>
            <span class="modern-rate-tile-unit">/min</span>
          </div>
          <div class="modern-rate-tile-meta">
            <app-rolling-counter [value]="ent.inVenue"></app-rolling-counter>
            <span class="modern-rate-tile-unit">inside</span>
          </div>
        </ng-container>
        <ng-template #entranceInsidePrimary>
          <div class="modern-rate-tile-value">
            <app-rolling-counter [value]="ent.inVenue"></app-rolling-counter>
            <span class="modern-rate-tile-unit">inside</span>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- ===================== Errors by result code ===================== -->
  <div class="widget-grid-wrap" *ngSwitchCase="'errorsByResultCode'">
    <div class="widget-heading">
      <span [ngStyle]="titleStyle">{{ widget.title || 'Errors by Result Code' }}</span>
      <span class="widget-heading-sub">{{ hasScanRate ? 'scans per minute' : 'total errors' }}</span>
    </div>
    <div class="modern-error-grid" *ngIf="errorTiles.length; else noData">
      <div class="modern-error-tile" *ngFor="let err of errorTiles">
        <div class="modern-error-code">{{ formatErrorCode(err.code) }}</div>
        <div class="modern-error-rate" *ngIf="hasScanRate; else errorTotalPrimary">
          <app-rolling-counter [value]="err.rate" suffix="/min"></app-rolling-counter>
        </div>
        <ng-template #errorTotalPrimary>
          <div class="modern-error-rate">
            <app-rolling-counter [value]="err.total"></app-rolling-counter>
            <span class="modern-rate-tile-unit">total</span>
          </div>
        </ng-template>
        <div class="modern-error-meta">
          <ng-container *ngIf="hasScanRate">
            <app-rolling-counter [value]="err.total"></app-rolling-counter>
            <span>total &middot;</span>
          </ng-container>
          <app-rolling-counter [value]="err.percentOfEntries" [decimals]="2" suffix="%"></app-rolling-counter>
        </div>
        <div class="modern-error-events" *ngIf="err.events.length">
          {{ err.events.join(', ') }}
        </div>
      </div>
    </div>
  </div>

  <!-- ===================== Graphs ===================== -->
  <div class="widget-chart-wrap" *ngSwitchCase="'multiLineGraph'">
    <div class="widget-heading">
      <span [ngStyle]="titleStyle">{{ widget.title || 'Attendance Over Time' }}</span>
    </div>
    <div class="widget-chart" *ngIf="chartData.datasets.length; else noData">
      <canvas baseChart type="line" [data]="chartData" [options]="chartOptions"></canvas>
    </div>
  </div>

  <div class="widget-chart-wrap" *ngSwitchCase="'entranceGraph'">
    <div class="widget-heading">
      <span [ngStyle]="titleStyle">{{ widget.title || entranceGraphLabel }}</span>
    </div>
    <div class="widget-chart" *ngIf="chartData.datasets.length; else noData">
      <canvas baseChart type="line" [data]="chartData" [options]="chartOptions"></canvas>
    </div>
  </div>

  <!-- ===================== Text note ===================== -->
  <div class="widget-text" *ngSwitchCase="'textNote'">
    <div class="widget-text-body" *ngIf="widget.text; else emptyText"
      [style.font-size.px]="widget.fontSize || 32"
      [style.font-weight]="widget.bold ? 800 : null"
      [style.color]="widget.textColor || null">{{ widget.text }}</div>
    <ng-template #emptyText>
      <div class="widget-text-empty">{{ editing ? 'Add text in the widget settings.' : '' }}</div>
    </ng-template>
  </div>

  <!-- ===================== Standalone image ===================== -->
  <div class="widget-image" *ngSwitchCase="'image'">
    <img class="widget-image-img" *ngIf="widget.imageData; else noImage"
      [src]="widget.imageData" alt="Dashboard image" draggable="false" />
    <ng-template #noImage>
      <div class="widget-nodata">{{ editing ? 'Open settings (⚙) to upload an image.' : '' }}</div>
    </ng-template>
  </div>

  <!-- ===================== Venue map ===================== -->
  <app-venue-map-widget *ngSwitchCase="'venueMap'"
    [imageData]="widget.imageData"
    [markers]="widget.markers || []"
    [attendanceSummary]="attendanceSummary"
    [editing]="editing"
    [dark]="dark"
    (markersChange)="onMarkersChange($event)">
  </app-venue-map-widget>

  <ng-template #noData>
    <div class="widget-nodata">No data yet</div>
  </ng-template>
</div>
